export default "__VITE_ASSET__CI3IrGN0__"